module.exports = __webpack_public_path__ + "static/img/mobile_code.810df5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/newArea-appoint/mobile_code.png
// module id = Kxl5
// module chunks = 1